var _defs, _sodipodiNamedview;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOprWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 242.41068,
    height: 87.3536,
    viewBox: "0 0 242.41068 87.3536",
    sodipodiDocname: "OPRForetagslan2022white.ai",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,65.515 H 181.808 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "OPRForetagslan2022white",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,87.3536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(61.0413,34.6064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.502,0.921 0.904,1.893 1.2,2.9 0.248,1.218 0.382,2.457 0.4,3.7 0.032,1.279 -0.103,2.556 -0.4,3.8 -0.242,1.056 -0.647,2.068 -1.2,3 -0.512,0.779 -1.196,1.429 -2,1.9 -0.815,0.485 -1.752,0.728 -2.7,0.7 -1.022,0.01 -2.027,-0.268 -2.9,-0.8 -0.834,-0.519 -1.523,-1.241 -2,-2.1 -0.518,-0.938 -0.889,-1.95 -1.1,-3 -0.243,-1.185 -0.377,-2.39 -0.4,-3.6 -0.032,-1.246 0.103,-2.49 0.4,-3.7 0.189,-1.072 0.597,-2.093 1.2,-3 0.5,-0.782 1.145,-1.461 1.9,-2 0.846,-0.5 1.819,-0.743 2.8,-0.7 0.979,-0.018 1.945,0.224 2.8,0.7 0.77,0.632 1.444,1.373 2,2.2 M 2.1,14.4 C 3.027,13.423 3.742,12.266 4.2,11 5.267,8.164 5.267,5.036 4.2,2.2 3.718,0.946 3.006,-0.207 2.1,-1.2 0.292,-3.057 -2.21,-4.072 -4.8,-4 c -1.34,0.004 -2.666,0.276 -3.9,0.8 -1.168,0.522 -2.221,1.27 -3.1,2.2 -0.896,0.982 -1.577,2.14 -2,3.4 -0.491,1.345 -0.728,2.769 -0.7,4.2 -0.014,1.504 0.258,2.997 0.8,4.4 0.482,1.254 1.194,2.407 2.1,3.4 0.856,0.931 1.918,1.65 3.1,2.1 1.173,0.481 2.432,0.719 3.7,0.7 1.307,-0.016 2.598,-0.288 3.8,-0.8 1.189,-0.388 2.257,-1.077 3.1,-2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(79.3413,42.9064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.283,0.427 0.486,0.901 0.6,1.4 0.708,1.826 0.775,2.261 0.8,2.7 0.777,3.271 0.71,3.839 0.6,4.4 0.491,4.949 0.251,5.464 -0.1,5.9 c -0.341,0.439 -0.788,0.783 -1.3,1 -0.635,0.258 -1.314,0.394 -2,0.4 h -2 v -9 h 1.5 c 0.86,-0.02 1.714,0.151 2.5,0.5 0.508,0.349 0.977,0.752 1.4,1.2 M 4.3,3.5 C 4.325,2.532 4.12,1.572 3.7,0.7 3.303,-0.094 2.72,-0.78 2,-1.3 1.264,-1.818 0.455,-2.222 -0.4,-2.5 -1.315,-2.738 -2.255,-2.872 -3.2,-2.9 h -2.3 v -6.2 c 0.019,-0.309 0.086,-0.612 0.2,-0.9 0.1,-0.3 0.3,-0.4 0.7,-0.6 0.295,-0.088 0.596,-0.155 0.9,-0.2 0.394,-0.083 0.797,-0.116 1.2,-0.1 v -1 h -8.7 v 1 c 0.2,0 0.6,0.1 1,0.1 0.311,-0.004 0.62,0.064 0.9,0.2 0.26,0.078 0.476,0.259 0.6,0.5 0.136,0.28 0.204,0.589 0.2,0.9 V 5.6 c 0.016,0.303 -0.018,0.608 -0.1,0.9 -0.102,0.316 -0.372,0.548 -0.7,0.6 l -1.1,0.3 c -0.294,0.073 -0.597,0.106 -0.9,0.1 v 1 H -2 C -0.354,8.558 1.265,8.065 2.6,7.1 3.701,6.234 4.33,4.9 4.3,3.5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(97.7413,46.2064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.038,1.075 -0.358,2.121 -1.1,2.9 -0.809,0.759 -1.892,1.156 -3,1.1 h -2.4 v -8.7 h 1.9 c 1.233,-0.043 2.428,0.428 3.3,1.3 0.891,0.901 1.362,2.135 1.3,3.4 M 7.6,-15.1 H 2.1 c -1.2,1.9 -2.3,3.5 -3.3,4.9 -1,1.4 -2,2.8 -3.2,4.3 h -2.1 v -6.4 c 0.019,-0.309 0.086,-0.612 0.2,-0.9 0.1,-0.3 0.3,-0.4 0.7,-0.6 0.295,-0.088 0.596,-0.155 0.9,-0.2 0.361,-0.079 0.731,-0.112 1.1,-0.1 v -1 h -8.6 v 1 c 0.2,0 0.6,0.1 1,0.1 0.311,-0.004 0.62,0.064 0.9,0.2 0.26,0.078 0.476,0.259 0.6,0.5 0.136,0.28 0.204,0.589 0.2,0.9 V 2.4 c 0.016,0.303 -0.018,0.608 -0.1,0.9 -0.102,0.316 -0.372,0.548 -0.7,0.6 -0.28,0.136 -0.589,0.204 -0.9,0.2 -0.327,0.078 -0.664,0.112 -1,0.1 v 1 h 9.4 C -1.99,5.212 -1.182,5.111 -0.4,4.9 0.315,4.723 0.993,4.418 1.6,4 2.853,3.199 3.579,1.786 3.5,0.3 3.532,-0.422 3.395,-1.141 3.1,-1.8 2.864,-2.412 2.487,-2.96 2,-3.4 1.562,-3.845 1.056,-4.216 0.5,-4.5 c -0.641,-0.326 -1.311,-0.594 -2,-0.8 1,-1.3 1.8,-2.4 2.5,-3.4 0.7,-1 1.5,-2 2.4,-3.3 0.32,-0.471 0.689,-0.906 1.1,-1.3 0.309,-0.266 0.644,-0.501 1,-0.7 0.295,-0.115 0.595,-0.215 0.9,-0.3 0.294,-0.073 0.597,-0.106 0.9,-0.1 v -0.7 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(38.8413,41.0064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.017,0.737 -0.084,1.472 -0.2,2.2 -0.3,2.5 -0.5,2.7 -0.6,3 -3.23,6.979 -8.382,8.427 -12.7,6.4 -16.978,4.316 -19.194,-0.494 -18,-5.1 c 0.769,-2.721 2.713,-4.958 5.3,-6.1 1.701,-0.728 3.57,-0.971 5.4,-0.7 l 1.1,0.3 C -2.306,-9.029 0.026,-4.666 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(16.4413,44.7064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -1.194,-3.743 -0.525,-7.832 1.8,-11 0.865,-9.344 0.318,-7.498 0.2,-5.6 0.026,0.372 3.945,5.694 9.7,7.3 12.149,7.982 14.734,8.017 17.2,7.4 16.366,8.117 15.42,8.691 14.4,9.1 14,9.1 13.7,9.2 13.3,9.2 7.4,9.2 1.7,5.5 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(20.2413,33.5064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -2.592,5.274 -0.726,11.654 4.3,14.7 4.138,2.45 9.381,1.966 13,-1.2 -0.458,0.942 -0.993,1.845 -1.6,2.7 C 10.923,18.814 4.998,18.003 1.1,14.2 -2.95,10.147 -3.211,3.665 0.5,-0.7 0.3,-0.6 0.2,-0.3 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(20.4413,29.6064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -4.89,3.19 -7.187,9.154 -5.7,14.8 1.588,5.477 6.104,9.607 11.7,10.7 -0.562,0.086 -1.131,0.12 -1.7,0.1 -7.787,0 -14.1,-6.313 -14.1,-14.1 0,-7.787 6.313,-14.1 14.1,-14.1 1.008,-0.004 2.013,0.096 3,0.3 C 4.69,-2.291 2.144,-1.489 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(57.4413,14.8064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -1.6 V 10 H 4 V 8.6 H 0 V 5.5 H 3.8 V 4.1 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g50",
    transform: "translate(67.0413,24.4064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.013,0.218 0.059,0.433 0.2,0.6 0.375,0.726 0.584,0.795 0.8,0.8 1.012,0.779 1.218,0.711 1.4,0.6 1.541,0.433 1.613,0.218 1.6,0 1.579,-0.212 1.511,-0.418 1.4,-0.6 1.3,-0.8 1.1,-0.8 0.8,-0.8 0.587,-0.779 0.382,-0.711 0.2,-0.6 0.059,-0.433 -0.013,-0.218 0,0 m -2.5,-5.8 c 0,-1.7 0.6,-2.6 1.9,-2.6 1.3,0 1.9,0.9 1.9,2.6 0,1.7 -0.6,2.6 -1.9,2.6 -0.592,0.068 -1.172,-0.202 -1.5,-0.7 -0.282,-0.593 -0.419,-1.244 -0.4,-1.9 M -2.7,0 c -0.013,0.218 0.059,0.433 0.2,0.6 0.175,0.126 0.384,0.195 0.6,0.2 0.212,-0.021 0.418,-0.089 0.6,-0.2 0.141,-0.167 0.213,-0.382 0.2,-0.6 -0.021,-0.212 -0.089,-0.418 -0.2,-0.6 -0.167,-0.141 -0.382,-0.213 -0.6,-0.2 -0.213,0.021 -0.418,0.089 -0.6,0.2 -0.141,0.167 -0.213,0.382 -0.2,0.6 M 3,-5.8 c 0.065,-1.061 -0.295,-2.105 -1,-2.9 -0.673,-0.707 -1.627,-1.074 -2.6,-1 -0.664,0.012 -1.316,0.183 -1.9,0.5 -0.554,0.338 -1.004,0.823 -1.3,1.4 -0.295,0.659 -0.432,1.378 -0.4,2.1 -0.056,1.043 0.263,2.072 0.9,2.9 1.516,1.372 3.837,1.328 5.3,-0.1 0.67,-0.816 1.024,-1.845 1,-2.9",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "translate(76.0413,22.5064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.271,0.021 0.543,-0.013 0.8,-0.1 L 0.6,-1.5 c -0.224,0.082 -0.462,0.116 -0.7,0.1 -1.135,0.08 -2.12,-0.775 -2.2,-1.91 -0.007,-0.096 -0.007,-0.193 0,-0.29 v -4 H -3.9 V 0 h 1.3 l 0.2,-1.3 h 0.1 c 0.252,0.433 0.593,0.808 1,1.1 0.423,0.123 0.86,0.19 1.3,0.2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g58",
    transform: "translate(81.2413,21.3064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.451,0.003 -0.885,-0.177 -1.2,-0.5 -1.536,-0.896 -1.745,-1.384 -1.8,-1.9 H 1.6 C 1.619,-1.386 1.44,-0.885 1.1,-0.5 0.839,-0.161 0.427,0.026 0,0 m 0.3,-6.6 c -1.907,-0.192 -3.608,1.198 -3.8,3.105 -0.023,0.231 -0.023,0.464 0,0.695 -0.056,1.043 0.263,2.072 0.9,2.9 1.308,1.386 3.483,1.475 4.9,0.2 0.634,-0.672 0.96,-1.578 0.9,-2.5 v -0.9 h -5 c -0.034,-0.624 0.182,-1.236 0.6,-1.7 0.425,-0.417 1.006,-0.635 1.6,-0.6 0.403,-0.021 0.806,0.013 1.2,0.1 0.414,0.088 0.816,0.222 1.2,0.4 V -6.2 C 2.416,-6.378 2.014,-6.512 1.6,-6.6 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62",
    transform: "translate(89.9413,16.0064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.407,0.018 0.81,0.085 1.2,0.2 V -1 C 0.971,-1.08 0.737,-1.147 0.5,-1.2 0.208,-1.282 -0.097,-1.316 -0.4,-1.3 -1.547,-1.43 -2.582,-0.605 -2.712,0.542 -2.733,0.727 -2.729,0.915 -2.7,1.1 v 4.1 h -1 v 0.7 l 1.1,0.6 0.5,1.6 h 1 V 6.4 H 1.1 V 5.2 h -2.2 v -4 C -1.126,0.872 -1.017,0.547 -0.8,0.3 -0.582,0.1 -0.295,-0.007 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(95.8413,15.9064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.514,-0.019 1.015,0.16 1.4,0.5 0.384,0.358 0.57,0.88 0.5,1.4 v 0.7 h -1 C 0.309,2.611 -0.276,2.474 -0.8,2.2 -1.117,1.966 -1.303,1.594 -1.3,1.2 -1.307,0.905 -1.2,0.618 -1,0.4 -0.742,0.126 -0.376,-0.02 0,0 M 2.4,-1.1 2.1,0 H 2 C 1.743,-0.413 1.356,-0.73 0.9,-0.9 0.456,-1.077 -0.024,-1.146 -0.5,-1.1 c -1.148,-0.123 -2.178,0.709 -2.3,1.856 -0.016,0.148 -0.016,0.297 0,0.444 -0.046,0.718 0.298,1.406 0.9,1.8 0.792,0.444 1.694,0.652 2.6,0.6 H 2 V 4 C 2.022,4.389 1.917,4.776 1.7,5.1 1.453,5.389 1.079,5.539 0.7,5.5 0.325,5.491 -0.046,5.424 -0.4,5.3 -0.755,5.228 -1.094,5.093 -1.4,4.9 L -1.9,6 c 0.415,0.21 0.851,0.377 1.3,0.5 0.458,0.116 0.928,0.183 1.4,0.2 C 1.581,6.759 2.358,6.547 3,6.1 3.526,5.575 3.783,4.838 3.7,4.1 v -5.2 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "translate(103.5413,19.9064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.038,-0.408 0.109,-0.812 0.4,-1.1 0.647,-1.389 1.021,-1.539 1.4,-1.5 2.3,-1.5 2.8,-1 2.8,0 2.838,0.391 2.731,0.782 2.5,1.1 2.253,1.389 1.879,1.539 1.5,1.5 1.092,1.538 0.688,1.391 0.4,1.1 0.093,0.822 -0.057,0.41 0,0 m -0.7,-6.2 c 0.023,-0.333 0.21,-0.634 0.5,-0.8 0.398,-0.216 0.848,-0.32 1.3,-0.3 0.691,-0.055 1.383,0.084 2,0.4 0.375,0.191 0.608,0.579 0.6,1 0.038,0.296 -0.125,0.582 -0.4,0.7 C 2.883,-5.051 2.442,-4.983 2,-5 H 0.8 C 0.13,-4.856 -0.529,-5.283 -0.672,-5.952 -0.69,-6.034 -0.699,-6.117 -0.7,-6.2 m 6,8.7 V 1.6 L 4,1.4 4.3,0.8 C 4.382,0.576 4.416,0.338 4.4,0.1 4.432,-0.593 4.135,-1.26 3.6,-1.7 2.963,-2.168 2.19,-2.414 1.4,-2.4 1.162,-2.416 0.924,-2.382 0.7,-2.3 0.41,-2.466 0.223,-2.767 0.2,-3.1 0.203,-3.257 0.276,-3.404 0.4,-3.5 0.69,-3.595 0.996,-3.629 1.3,-3.6 H 2.6 C 3.269,-3.571 3.932,-3.745 4.5,-4.1 4.902,-4.493 5.12,-5.038 5.1,-5.6 5.111,-6.414 4.693,-7.174 4,-7.6 3.063,-8.147 1.981,-8.391 0.9,-8.3 c -0.828,-0.021 -1.649,0.15 -2.4,0.5 -0.511,0.371 -0.81,0.968 -0.8,1.6 -0.038,0.438 0.106,0.873 0.4,1.2 0.349,0.312 0.757,0.55 1.2,0.7 -0.206,0.075 -0.382,0.215 -0.5,0.4 -0.111,0.182 -0.179,0.388 -0.2,0.6 0.006,0.247 0.075,0.487 0.2,0.7 0.211,0.224 0.446,0.425 0.7,0.6 -0.396,0.177 -0.74,0.452 -1,0.8 -0.237,0.395 -0.374,0.841 -0.4,1.3 -0.031,0.721 0.262,1.418 0.8,1.9 0.614,0.511 1.404,0.762 2.2,0.7 H 1.8 C 1.968,2.677 2.135,2.643 2.3,2.6 h 3 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74",
    transform: "translate(116.1413,17.0064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.01,-0.66 -0.286,-1.287 -0.8,-1.7 -0.68,-0.447 -1.488,-0.658 -2.3,-0.6 -0.828,-0.021 -1.649,0.15 -2.4,0.5 v 1.4 c 0.781,-0.376 1.633,-0.58 2.5,-0.6 1,0 1.5,0.3 1.5,0.9 -0.003,0.185 -0.075,0.363 -0.2,0.5 -0.146,0.157 -0.315,0.292 -0.5,0.4 l -1,0.5 c -0.666,0.197 -1.281,0.539 -1.8,1 -0.702,0.75 -0.662,1.927 0.088,2.629 0.066,0.062 0.137,0.119 0.212,0.171 0.624,0.399 1.364,0.575 2.1,0.5 0.857,-0.012 1.704,-0.182 2.5,-0.5 L -0.6,3.9 C -1.266,4.186 -1.977,4.355 -2.7,4.4 -3.5,4.4 -4,4.2 -4,3.7 -3.985,3.468 -3.877,3.251 -3.7,3.1 -3.267,2.804 -2.796,2.569 -2.3,2.4 -1.805,2.229 -1.334,1.993 -0.9,1.7 -0.624,1.545 -0.411,1.297 -0.3,1 -0.11,0.701 -0.006,0.355 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 120.041,14.806 h -1.6 v 10.7 h 1.6 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g80",
    transform: "translate(126.5413,24.9064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.001,0.387 -0.311,0.701 -0.698,0.702 -1.085,0.703 -1.399,0.391 -1.4,0.004 V 0 c 0,-0.5 0.2,-0.7 0.7,-0.7 0.185,0.003 0.363,0.075 0.5,0.2 C 0,-0.5 0,-0.3 0,0 Z m 1,0 c 0.038,-0.408 -0.109,-0.812 -0.4,-1.1 -0.711,-0.533 -1.689,-0.533 -2.4,0 -0.277,0.297 -0.421,0.694 -0.4,1.1 -0.038,0.408 0.109,0.812 0.4,1.1 0.711,0.533 1.689,0.533 2.4,0 C 0.835,0.779 0.974,0.397 1,0 Z m -2.3,-9 c 0.514,-0.019 1.015,0.16 1.4,0.5 0.384,0.358 0.57,0.88 0.5,1.4 v 0.7 h -1 c -0.591,0.011 -1.176,-0.126 -1.7,-0.4 -0.317,-0.234 -0.503,-0.606 -0.5,-1 -0.007,-0.295 0.1,-0.582 0.3,-0.8 0.258,-0.274 0.624,-0.42 1,-0.4 M 1.1,-10.1 0.8,-9 H 0.7 c -0.257,-0.413 -0.644,-0.73 -1.1,-0.9 -0.444,-0.177 -0.924,-0.246 -1.4,-0.2 -1.148,-0.123 -2.178,0.709 -2.3,1.856 -0.016,0.148 -0.016,0.297 0,0.444 -0.046,0.718 0.298,1.406 0.9,1.8 0.792,0.444 1.694,0.652 2.6,0.6 H 0.7 V -5 c 0.022,0.389 -0.083,0.776 -0.3,1.1 -0.248,0.289 -0.621,0.439 -1,0.4 -0.375,-0.009 -0.746,-0.076 -1.1,-0.2 -0.355,-0.072 -0.694,-0.207 -1,-0.4 L -3.2,-3 c 0.415,0.21 0.851,0.377 1.3,0.5 0.458,0.115 0.928,0.183 1.4,0.2 0.781,0.059 1.558,-0.153 2.2,-0.6 0.526,-0.525 0.783,-1.262 0.7,-2 v -5.2 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g84",
    transform: "translate(138.2413,14.8064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -1.6 V 4.6 C -1.547,5.07 -1.692,5.541 -2,5.9 -2.278,6.207 -2.69,6.357 -3.1,6.3 -3.668,6.357 -4.228,6.133 -4.6,5.7 -4.967,5.1 -5.142,4.402 -5.1,3.7 V 0 h -1.6 v 7.6 h 1.3 l 0.2,-1 h 0.1 c 0.237,0.369 0.588,0.65 1,0.8 0.438,0.205 0.917,0.307 1.4,0.3 C -0.9,7.7 0,6.8 0,4.9 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOprWhite);
export default __webpack_public_path__ + "static/media/opr_white.76801490cd52cb8983f36ba20d238f96.svg";
export { ForwardRef as ReactComponent };